import React from 'react'
import { withPrefix } from 'gatsby'
import ZoomSlider from './ZoomSlider.jsx'
import Tooltip from '../tooltip/Tooltip.jsx'
import { ViewerContext } from '../context/ViewerContext.jsx'
import * as R from 'ramda'
import { seaDragonProps } from '../types'
class SeadragonViewer extends React.Component {
  static propTypes = seaDragonProps
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth
    this.minZoom =
      windowWidth / windowHeight > 1.6 ? 0 : this.context.state.minZoom
    this.initSeaDragon(this.minZoom)
    document.querySelector('#zoom-in').removeAttribute('title')
    document.querySelector('#zoom-out').removeAttribute('title')
  }
  componentWillUnmount() {
    this.context.highlightSection('')
    this.props.setZoomLevelState(this.context.state.minZoom)
    // we're resetting the highlighted section and zoom level on page change
  }
  renderSectionOverlays = (sections, colorNotes) => {
    const newSection = R.map(
      section => R.pick(['sectionId', 'coordinates'], section),
      sections
    )
    const sectionCoordinates = R.map(
      section =>
        R.mergeAll([
          { id: section.sectionId },
          { type: 'section' },
          section.coordinates,
          {
            className: 'viewer-overlay',
          },
        ]),
      newSection
    )
    const colorNoteCoordinates = R.map(
      notes =>
        R.mergeAll([
          { id: notes.id },
          { parentSection: notes.sectionId },
          { type: 'colorNotes' },
          notes.coordinates,
          {
            className: 'viewer-overlay',
          },
        ]),
      colorNotes
    )
    return this.concatArrays(sectionCoordinates, colorNoteCoordinates)
  }

  concatArrays = (leftArr, rightArr) => {
    return leftArr.concat(rightArr)
  }

  initSeaDragon(minZoom) {
    const OpenSeadragon = require('openseadragon')
    const tiles = this.props.tilePrefix + this.props.folioNum
    const setZoomLevel = this.props.setZoomLevelState

    let overlayArr = []
    if (this.props.currentView.includes('documents')) {
      overlayArr = this.concatArrays(
        this.renderSectionOverlays(
          this.props.leftSections,
          this.props.leftColorNotes
        ),
        this.renderSectionOverlays(
          this.props.rightSections,
          this.props.rightColorNotes
        )
      )
    }
    const viewer = new OpenSeadragon({
      id: 'sd-mount',
      tileSources: withPrefix(`/tiles/${tiles}/${tiles}.dzi`),
      showHomeControl: false,
      showFullPageControl: false,
      zoomInButton: 'zoom-in',
      zoomOutButton: 'zoom-out',
      visibilityRatio: 1,
      constrainDuringPan: true,
      defaultZoomLevel: minZoom,
      maxZoomLevel: this.context.state.maxZoom,
      minZoomLevel: minZoom,
      zoomPerClick: 1,
    })

    this.context.storeViewer(viewer)
    this.context.getSections(overlayArr)
    viewer.addHandler('canvas-click', this.context.handleOverlayClick)
    viewer.addOnceHandler('open', function() {
      let zoomScroll = new OpenSeadragon.MouseTracker({
        element: 'sd-mount',
        scrollHandler: function(e) {
          setZoomLevel(viewer.viewport.getZoom(false))
        },
      })
      let zoomInTracker = new OpenSeadragon.MouseTracker({
        element: 'zoom-in',
        clickHandler: function(e) {
          setZoomLevel(viewer.viewport.getZoom(false))
          viewer.zoomPerClick = 2
        },
      })
      let zoomOutTracker = new OpenSeadragon.MouseTracker({
        element: 'zoom-out',
        clickHandler: function(e) {
          setZoomLevel(viewer.viewport.getZoom(false))
          viewer.zoomPerClick = 2
        },
      })
    })
  }
  renderZoomOut = () => {
    return (
      <Tooltip tooltipText="Zoom Out" tooltiplLRPosition="right">
        <button
          id="zoom-out"
          disabled={
            this.context.state.zoomLevel.toFixed(2) ===
            this.context.state.minZoom.toFixed(2)
          }
          type="button"
        >
          <span className="zoom-out__icon" />
          <span className="visually-hidden">Zoom Out</span>
        </button>
      </Tooltip>
    )
  }
  renderZoomIn = () => {
    return (
      <Tooltip
        tooltipText="Zoom In"
        tooltipPosition="above"
        tooltiplLRPosition="right"
      >
        <button
          id="zoom-in"
          disabled={
            this.context.state.zoomLevel.toFixed(2) ===
            this.context.state.maxZoom.toFixed(2)
          }
          type="button"
        >
          <span className="zoom-in__icon" />

          <span className="visually-hidden">Zoom In</span>
        </button>
      </Tooltip>
    )
  }
  renderCSS = highlightedId => {
    return `.${highlightedId} #${highlightedId} { border: #0050bc solid 2px  }`
  }
  render() {
    const highlightedSection = this.props.highlightedSection

    return (
      <React.Fragment>
        {highlightedSection ? (
          <style
            dangerouslySetInnerHTML={{
              __html: this.renderCSS(highlightedSection),
            }}
          />
        ) : (
          ''
        )}
        <div id="sd-mount" className={highlightedSection} />
        <div className="viewer-overlay sd-overlay" />
        <div className="zoom-navigation">
          {this.renderZoomIn()}
          <ZoomSlider
            updateZoomLevel={this.context.updateZoomLevel}
            setZoomLevelState={this.context.setZoomLevelState}
            currentZoom={this.context.state.zoomLevel}
            maxZoom={this.context.state.maxZoom}
            minZoom={this.minZoom}
          />
          {this.renderZoomOut()}
        </div>
      </React.Fragment>
    )
  }
}
SeadragonViewer.contextType = ViewerContext
export default SeadragonViewer
